import { useContext } from "react";
import { BooleanField, Datagrid, DateField, List, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";
const ExternalServiceRequestList = ({ permissions, ...props }) => {
    const context = useContext(AppContext)


    return <List
        exporter={false}
        bulkActionButtons={false}
        title={'Pedidos de atendimento externos'}
        sort={{ field: 'start_at', order: 'DESC' }}
        {...props}
    >
        <Datagrid rowClick={'edit'}>
            <TextField source="name" label={'Nome'} />
            {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
            {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            <DateField source="start_at" label={'Data Início'} />
            <DateField source="end_at" label={'Data Fim'} />
            <BooleanField source="available" label={'Disponível'} />
        </Datagrid>
    </List>
}

export default ExternalServiceRequestList;